import identity from 'lodash/fp/identity'

export const formatStringWith =
  (separator = ' ') =>
  (...strings: string[]) =>
    strings.filter(identity).join(separator)
